<div class="contains-button">

  <div style="display: flex; align-items: center; gap: 4px; flex-wrap: wrap;">
    <button [ngClass]="configMode == 'basic' ? 'ant-btn ant-btn-primary' : 'ant-btn'" class="d-flex align-items-center" (click)="configMode = 'basic'">
      <span>{{('cau_hinh_co_ban') | translate}}</span>
    </button>
  
    <button [ngClass]="configMode == 'advanced' ? 'ant-btn ant-btn-primary' : 'ant-btn'" class="d-flex align-items-center" (click)="configMode = 'advanced'">
      <span>{{('cau_hinh_nang_cao') | translate}}</span>
    </button>
  </div>
  <!-- Cấu hình cơ bản -->
  <ng-container *ngIf="configMode == 'basic'">
    <div style="margin-top: 10px">
      <div class="config-text" style="width: 100%">
        <!-- Nhập nội dung của nút -->
        <mat-form-field style="width: 100%">
          <mat-label> {{'noi_dung' | translate}}</mat-label>
          <textarea matInput
            [ngModel]="staticdata['content_' + functionService.selectedLanguageCode] | vhLanguage : 'content' : objectChoosing.component"
            (ngModelChange)="staticdata['content_' + functionService.selectedLanguageCode] = $event"
            (blur)="updateStaticData();"></textarea>
        </mat-form-field>
        <!-- Nếu nội dung không có thì phải có nhãn -->
        <mat-form-field style="width: 100%" class="aria-label-input" [matTooltip]="'*_giai_thich_aria_label' | translate"
        *ngIf="!staticdata['content_' + functionService.selectedLanguageCode]?.trim()">
          <mat-label>{{'nhan_cua_nut' | translate}}<span style="color: red">*</span></mat-label>
          <textarea matInput
            [ngModel]="staticdata.accessibility?.['aria_label_' + functionService.selectedLanguageCode]"
            (ngModelChange)="staticdata.accessibility['aria_label_' + functionService.selectedLanguageCode] = $event"
            (blur)="updateStaticData();"></textarea>
        </mat-form-field>
      </div>

      <app-text-format-config
        [device]="device"
        [objectChoosing]="objectChoosing"
        [class]="class"
        [config]="config"
        
        [staticdata]="staticdata"
        [textContentClass]="class['button__content']"
        [textWrapperClass]="class['button']"
      >
      </app-text-format-config>

    </div>
  </ng-container>

  <!-- Hiển thị tiêu đề mở rộng -->
  <div class="editor-header" *ngIf="isViewAll">
    <i class="bi bi-chevron-left" (click)="isViewAll = !isViewAll"></i>
    <span (click)="isViewAll = !isViewAll">{{ currentViewAll.title | translate }}</span>
  </div>
  <ng-container *ngIf="!isViewAll && configMode == 'advanced'">
    <ul nz-menu nzMode="inline" >
      <!-- Cấu hình thông số cơ bản của button-->
      <li nz-submenu nzTitle="{{'hien_thi'| translate}}" [(nzOpen)]="openMap.menu1" (nzOpenChange)="openHandler('menu1')">
        <div class="button-size">
          <!-- Lựa chọn hiển thị cho các thiết bị -->
          <app-hide-show-config
              [device]="device"
              [elementChoosing]="objectChoosing">
          </app-hide-show-config>
        </div>
      </li>
      <!-- Cấu hình tái sử dụng thiết kế-->
      

      <!-- Cấu hình format font name của button -->
      <li nz-submenu nzTitle="{{'dinh_dang_ten_nut' | translate}}" [(nzOpen)]="openMap.menu2" (nzOpenChange)="openHandler('menu2')">
        <div class="container-font">
          <!-- chọn ngôn ngữ đa ngôn ngữ -->
          <div class="mb-3">
            
          </div>
          
          <div class="config-text" style="width: 100%">
            <!-- Nhập nội dung của nút -->
            <mat-form-field style="width: 100%">
              <mat-label> {{'noi_dung' | translate}}</mat-label>
              <textarea matInput
                [ngModel]="staticdata['content_' + functionService.selectedLanguageCode] | vhLanguage : 'content' : objectChoosing.component"
                (ngModelChange)="staticdata['content_' + functionService.selectedLanguageCode] = $event"
                (blur)="updateStaticData();"></textarea>
            </mat-form-field>
            <!-- Nếu nội dung không có thì phải có nhãn -->
            <mat-form-field style="width: 100%" class="aria-label-input" [matTooltip]="'*_giai_thich_aria_label' | translate"
            *ngIf="!staticdata['content_' + functionService.selectedLanguageCode]?.trim()">
              <mat-label>{{'nhan_cua_nut' | translate}}<span style="color: red">*</span></mat-label>
              <textarea matInput
                [ngModel]="staticdata.accessibility?.['aria_label_' + functionService.selectedLanguageCode]"
                (ngModelChange)="staticdata.accessibility['aria_label_' + functionService.selectedLanguageCode] = $event"
                (blur)="updateStaticData();"></textarea>
            </mat-form-field>
          </div>

          <app-text-format-config
                  [device]="device"
                  [objectChoosing]="objectChoosing"
                  [class]="class"
                  [config]="config"
                  
                  [staticdata]="staticdata"
                  [textContentClass]="class['button__content']"
                  [textWrapperClass]="class['button']"
                  >
          </app-text-format-config>
          <div class="font-adjusting">
            <div class="row-spacing">
              <span class="title">{{'gian_cach_chu' | translate}}</span>
              <nz-input-number [nzMin]="0" [nzMax]="30" [ngStyle]="{ width: '40%' }" [ngModel]="
                    class['button__content']['letter-spacing'] | vhnumber
                  " (nzBlur)="updateClass()" (ngModelChange)="
                    class['button__content']['letter-spacing'] =
                      $event + 'px'
                  "></nz-input-number>
            </div>
            <nz-slider [nzMin]="0" [nzMax]="30" [ngModel]="
                      class['button__content']['letter-spacing'] | vhnumber
                    " (nzOnAfterChange)="updateClass()" (ngModelChange)="
                      class['button__content']['letter-spacing'] =
                        $event + 'px'
                    "></nz-slider>
          </div>
          <div class="font-adjusting">
            <div class="row-spacing">
              <span class="title">{{'khoang_cach_dong' | translate}}</span>
              <nz-input-number [nzMin]="0" [nzMax]="3" [ngStyle]="{ width: '40%' }" [nzStep]="0.1"
                [(ngModel)]="class['button__content']['line-height']" (nzBlur)="updateClass()"></nz-input-number>
            </div>
            <nz-slider [nzMin]="0" [nzMax]="3" [nzStep]="0.1" [(ngModel)]="class['button__content']['line-height']"
              (nzOnAfterChange)="updateClass()"></nz-slider>
          </div>

          <label class="px-1">{{'gian_cach' | translate}}</label>
          <div class="padding">
            <div class="d-flex items">
              <img src="assets/root/images/system/icons/padding-top.svg" alt="1" width="30px">
              <nz-input-number [nzMin]="0" [nzMax]="200" style="max-width: 50%;" [nzStep]="1"
                [ngModel]="class['button']['padding-top']| vhnumber" (nzBlur)="updateClassAndWidthHeight()"
                (ngModelChange)="class['button']['padding-top'] = $event + 'px'; class['button']['padding-bottom'] = $event + 'px'"></nz-input-number>
            </div>
            <div class="d-flex items">
              <img src="assets/root/images/system/icons/padding-right-left.svg" alt="1"
                width="30px">
              <nz-input-number [nzMin]="0" [nzMax]="200" style="max-width: 50%;" [nzStep]="1"
                [ngModel]="class['button']['padding-left'] | vhnumber " (nzBlur)="updateClassAndWidthHeight()"
                (ngModelChange)="class['button']['padding-right'] = $event + 'px'; class['button']['padding-left'] = $event + 'px'"></nz-input-number>
            </div>
          </div>
        </div>
      </li>
      <!-- Cấu hình file -->
      <li nz-submenu nzTitle="{{'cau_hinh_file' | translate}}" [(nzOpen)]="openMap.menu8" (nzOpenChange)="openHandler('menu8')">

        <ul>
          <!-- Định dạng chữ -->
          <li class="pl-2" nz-submenu nzTitle="{{'dinh_dang_chu' | translate}}">

            <div>
              <button nzType="default" class="button-position" (click)="handleAlign('right')" nzTooltipTitle="right-out"
                nzTooltipPlacement="bottom" nz-tooltip>
                <svg width="14px" height="14px" version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg"
                  xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 16 16"
                  style="enable-background:new 0 0 16 16;" xml:space="preserve">
                  <style type="text/css">
                    .st0 {
                      fill: none;
                      stroke: #000000;
                      stroke-width: 0.5;
                      stroke-miterlimit: 10;
                    }
                  </style>
                  <path class="st0"
                    d="M13,7v2c0,0.6-0.4,1-1,1H2c-0.6,0-1-0.4-1-1V7c0-0.6,0.4-1,1-1h10C12.6,6,13,6.4,13,7z" />
                  <path class="st0" d="M14,14.5v-13C14,1.2,14.2,1,14.5,1l0,0C14.8,1,15,1.2,15,1.5v13c0,0.3-0.2,0.5-0.5,0.5l0,0
             C14.2,15,14,14.8,14,14.5z" />
                </svg>
              </button>

              <button nzType="default" class="button-position" (click)="handleAlign('top')" nzTooltipTitle="top-out"
                nzTooltipPlacement="bottom" nz-tooltip>
                <svg _ngcontent-nag-c927="" width="14px" height="14px" version="1.1" id="Layer_1"
                  xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                  viewBox="0 0 16 16" xml:space="preserve" style="enable-background: new 0 0 16 16;">
                  <g _ngcontent-nag-c927="">
                    <path _ngcontent-nag-c927="" d="M9,15.2H7c-0.7,0-1.3-0.5-1.3-1.3V4c0-0.7,0.5-1.3,1.3-1.3h2c0.7,0,1.3,0.5,1.3,1.3v10C10.3,14.7,9.7,15.2,9,15.2z M7,3.2
                  C6.5,3.2,6.3,3.5,6.3,4v10c0,0.5,0.3,0.8,0.8,0.8h2c0.5,0,0.8-0.3,0.8-0.8V4c0-0.5-0.3-0.8-0.8-0.8H7z">
                    </path>
                  </g>
                  <g _ngcontent-nag-c927="">
                    <path _ngcontent-nag-c927="" d="M14.5,2.2h-13c-0.4,0-0.8-0.3-0.8-0.8s0.3-0.8,0.8-0.8h13c0.4,0,0.8,0.3,0.8,0.8S14.9,2.2,14.5,2.2z M1.5,1.2
                  c-0.2,0-0.3,0.1-0.3,0.3s0.1,0.3,0.3,0.3h13c0.2,0,0.3-0.1,0.3-0.3s-0.1-0.3-0.3-0.3H1.5z"></path>
                  </g>
                </svg>
              </button>

              <button nzType="default" class="button-position" (click)="handleAlign('bottom')"
                nzTooltipTitle="bottom-out" nzTooltipPlacement="bottom" nz-tooltip>


                <svg _ngcontent-ise-c927="" width="14px" height="14px" version="1.1" id="Layer_1"
                  xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                  viewBox="0 0 16 16" xml:space="preserve" style="enable-background: new 0 0 16 16;">
                  <style _ngcontent-ise-c927="" type="text/css">
                    .st0 {
                      fill: none;
                      stroke: #000000;
                      stroke-width: 0.5;
                      stroke-miterlimit: 10;
                    }
                  </style>
                  <path _ngcontent-ise-c927=""
                    d="M9,13H7c-0.6,0-1-0.4-1-1V2c0-0.6,0.4-1,1-1h2c0.6,0,1,0.4,1,1v10C10,12.6,9.6,13,9,13z"
                    class="st0"></path>
                  <path _ngcontent-ise-c927="" d="M14.5,15h-13C1.2,15,1,14.8,1,14.5v0C1,14.2,1.2,14,1.5,14h13c0.3,0,0.5,0.2,0.5,0.5v0C15,14.8,14.8,15,14.5,15
                  z" class="st0"></path>
                </svg>
              </button>
            </div>

            <div class="space-middle">
              <div class="slide-bar">
                <p class="m-0 title">{{'khoang_cach_chu_va_icon' | translate}}</p>
                <nz-input-number [ngModel]="class['file']['gap'] | vhnumber" (nzBlur)="updateClass()" style="width: 40%"
                  (ngModelChange)="class['file']['gap'] = $event + 'px'"></nz-input-number>
              </div>
              <nz-slider [ngModel]="class['file']['gap'] | vhnumber" (nzOnAfterChange)="updateClass()"
                (ngModelChange)="class['file']['gap'] = $event + 'px'"></nz-slider>
            </div>

            <div class="container-font">
              <div class="config-font-size">
                <div class="field-row-font" style="width: 65%">
                  <mat-form-field style="width: 100%">
                    <mat-label>Font</mat-label>
                    <mat-select [(ngModel)]="class['file-display__name']['font-family']" (ngModelChange)="updateClass()"
                      [(value)]="class['file-display__name']['font-family']">
                      <mat-option *ngFor="let font of fonts" [value]="font.value">{{
                        font.name
                        }}</mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>
                <div class="field-row-size" style="width: 35%">
                  <mat-form-field style="width: 100%">
                    <mat-label>{{'kich_thuoc' | translate}}</mat-label>
                    <input matInput type="number" [ngModel]="
                                class['file-display__name']['font-size'] | vhnumber
                              " (ngModelChange)="
                                class['file-display__name']['font-size'] =
                                  $event + 'px'
                              " />
                  </mat-form-field>
                </div>
              </div>
              <div class="config-font">
                <p class="title-font">{{'kieu_chu' | translate}}</p>
                <div class="field-row">
                  <button class="font-text-btn font-text-btn-bold" title="bold" nz-button [nzType]="
                              class['file-display__name']['font-weight'] == 'bold'
                                ? 'primary'
                                : 'default'
                            " (click)="
                              class['file-display__name']['font-weight'] =
                                class['file-display__name']['font-weight'] == 'bold'
                                  ? '500'
                                  : 'bold';
                              updateClass()
                            ">
                    <span style="font-weight: 600">B</span>
                  </button>
                  <button class="font-text-btn font-text-btn-italic" title="Italic" nz-button [nzType]="
                              class['file-display__name']['font-style'] == 'italic'
                                ? 'primary'
                                : 'default'
                            " (click)="
                              class['file-display__name']['font-style'] =
                                class['file-display__name']['font-style'] == 'normal'
                                  ? 'italic'
                                  : 'normal';
                              updateClass()
                            ">
                    <i nz-icon nzType="italic" nzTheme="outline" style="font-size: 14px"></i>
                  </button>
                  <button class="font-text-btn font-text-btn-underline" title="Underline" nz-button [nzType]="
                              class['file-display__name']['text-decoration'] ==
                              'underline'
                                ? 'primary'
                                : 'default'
                            " (click)="
                              class['file-display__name']['text-decoration'] =
                                class['file-display__name']['text-decoration'] ==
                                'none'
                                  ? 'underline'
                                  : 'none';
                              updateClass()
                            ">
                    <i nz-icon nzType="underline" nzTheme="outline" style="font-size: 14px"></i>
                  </button>
                  <button class="font-text-btn font-text-btn-uppercase" title="Uppercase" nz-button [nzType]="
                              class['file-display__name']['text-transform'] ==
                              'uppercase'
                                ? 'primary'
                                : 'default'
                            " (click)="
                              class['file-display__name']['text-transform'] =
                                class['file-display__name']['text-transform'] ==
                                'none'
                                  ? 'uppercase'
                                  : 'none';
                              updateClass()
                            ">
                    <span>AB</span>
                  </button>
                  <div>
                    <input id="color" type="button"  [cpOKButton]="true" [(colorPicker)]="class['file-display__name']['color']"
                      [style.background]="class['file-display__name']['color']" (colorPickerClose)="updateObject()"
                      [cpWidth]="'230px'" [cpPositionRelativeToArrow]="true" />
                  </div>
                </div>
              </div>
            </div>
          </li>
          <!-- Icon xóa file -->
          <li class="pl-2" nz-submenu nzTitle="Icon xóa file">

            <div class="d-flex justify-content-between mx-1">
              <mat-icon>{{config["flex-direction"].icon_delete_name }}</mat-icon>
              <button nz-button nzType="default" (click)="openDialogChooseIconDelete()" style="border-radius: 5px">
                {{'thay_doi' | translate}}
              </button>
            </div>
            <div class="font-size-symbol">
              <div class="slide-bar">
                <p class="m-0 title">{{'kich_thuoc' | translate}}</p>
                <nz-input-number [nzMin]="10" [nzMax]="50" style="width: 40%" [ngModel]="
                      class['file-display__icon']['font-size'] | vhnumber
                    " (nzBlur)="updateClass()" (ngModelChange)="
                      class['file-display__icon']['font-size'] =
                        $event + 'px'
                    "></nz-input-number>
              </div>
              <div class="font-size">
                <nz-slider [nzMin]="10" [nzMax]="50" [ngModel]="
                      class['file-display__icon']['font-size'] | vhnumber
                    " (nzOnAfterChange)="updateClass()" (ngModelChange)="
                      class['file-display__icon']['font-size'] =
                        $event + 'px'
                    "></nz-slider>
              </div>

              <div class="space-middle">
                <div class="slide-bar">
                  <p class="m-0 title w-50">{{ 'mau_sac' | translate }}</p>
                  <input style="width: 50%" class="input-color" type="button"
                    [cpOKButton]="true" [(colorPicker)]="class['file-display__icon'].color" [style.background]="
                    class['file-display__icon'].color" (colorPickerClose)="updateClass()" />
                </div>
              </div>
            </div>

          </li>
        </ul>

      </li>
      <!-- Cấu hình màu nền của button -->
      <li nz-submenu nzTitle="{{'mau_sac' | translate}}" [(nzOpen)]="openMap.menu3" (nzOpenChange)="openHandler('menu3')">
        <div class="container-color">
          <button id="btn-color" *ngFor="let background of backgroundColor; let i = index"
            [ngStyle]="{ 'background-color': background.bgColor }" (click)="chooseBg(background, $event)" nz-tooltip
            [disabled]="config['background-color'].gradient_check"></button>
        </div>
        <div class="color-pick">
          <span class="title w-50">{{'chon_mau' | translate}}</span>
          <input class="input-color w-50" type="button" [cpOKButton]="true" [(colorPicker)]="class['button']['background-color']"
            [style.background]="class['button']['background-color']" (colorPickerClose)="updateObject()"
            [cpWidth]="'230px'" />
        </div>
        <div class="mr-2 mb-4 mt-4 view-more"
          style="display: flex; align-items: center;justify-content: flex-end; gap: 7px">
          <p class="discover_text" (click)="openViewAll(styles_field[3])"
            style="cursor: pointer; text-align: left; margin: 0">
            {{'mo_rong' | translate}} &#8594;
          </p>
        </div>
        <!-- Mở popup so sánh màu tương phản -->
        <button *ngIf="staticdata['content_' + functionService.selectedLanguageCode]"
        nz-row (click)="openColorContrast()" nz-tooltip
        [nzTooltipTitle]="'dung_de_toi_uu_chi_so_accessibility_kha_nang_tiep_can_tren_pagespeed' | translate"
        style="color: #fff; background-color: #00a859; width: 100%; padding: 8px; border-radius: 8px;">
          {{ 'so_sanh_do_tuong_phan_giua_mau_chu_icon_va_mau_nen' | translate }}
        </button>
      </li>
      <!-- Cấu hình đổ bóng -->
      <li nz-submenu nzTitle="{{'do_bong' | translate}}" [(nzOpen)]="openMap.menu4" (nzOpenChange)="openHandler('menu4')">
        <app-shadow-config 
            [device]="device"
            [config]="config"
            [class]="class"
            [shadowClass]="class['button']"
            [shadowConfig]="config['box-shadow']"
            [objectChoosing]="objectChoosing"
            >
        </app-shadow-config>
      </li>
      <!-- Cấu hình hình dạng viền -->
      <li nz-submenu nzTitle="{{'kieu_vien' | translate}}" [(nzOpen)]="openMap.menu5" (nzOpenChange)="openHandler('menu5')">
        <app-borders-config [elementChoosing]="objectChoosing" [device]="device"
                          [class]="class"
                          [borderClass]="class['button']"
                          [id_object]="objectChoosing._id"
        >
        </app-borders-config>
        <!-- Nút mở rộng -->
        <div class="item-border my-3" style="float: right;">
          <p class="m-0 title-border my-2" (click)="openViewAll(styles_field[1])">{{'mo_rong' | translate}} &#8594;</p>
        </div>
      </li>
      <!-- Cấu hình biểu tượng -->
      <li nz-submenu nzTitle="{{'bieu_tuong' | translate}}" [(nzOpen)]="openMap.menu6" (nzOpenChange)="openHandler('menu6')">
        <app-symbol-config
              [device]="device"
              [class]="class"
              [config]="config"
              [symbolClass]="class['button']"
              [fontSizeIconClass]="class['button__content--icon']"
              [symbolConfig]="config['flex-direction']"
              [objectChoosing]="objectChoosing">
        </app-symbol-config>
      </li>
      <!-- Cấu hình thông báo -->
      <li nz-submenu nzTitle="{{'cau_hinh_thong_bao' | translate}}" [(nzOpen)]="openMap.menu11" (nzOpenChange)="openHandler('menu11')">
        <ng-template #notificationBlock let-dataKey="dataKey" let-configKey="configKey" let-label="label">
          <div class="config-text" style="width: 100%">
            <mat-form-field style="width: 100%">
              <mat-label> {{label | translate}}</mat-label>
              <textarea matInput
                [ngModel]="staticdata[dataKey]"
                (ngModelChange)="staticdata[dataKey] = $event"
                (blur)="updateStaticData()"></textarea>
            </mat-form-field>
        
            <div style="display:flex; justify-content:space-between; align-items:center">
              <span class="w-50" style="line-height:1.2;">{{ 'thoi_gian_hien_thong_bao' | translate }}</span>
              <nz-input-number
                [nzMin]="2000" [nzMax]="10000" [nzStep]="100"
                [ngStyle]="{ marginLeft: '16px', width: '40%' }"
                [ngModel]="config.duration_noti?.[configKey] | vhnumber"
                (ngModelChange)="config.duration_noti[configKey] = $event"
                (nzBlur)="updateConfig()" class="w-50">
              </nz-input-number>
            </div>
            <hr />
          </div>
        </ng-template>

        <ng-container *ngTemplateOutlet="notificationBlock; context: {
          dataKey: 'content_noti_success_' + functionService.selectedLanguageCode,
          configKey: 'success', label: 'tai_file_thanh_cong'
        }"></ng-container>
        <ng-container *ngTemplateOutlet="notificationBlock; context: {
          dataKey: 'content_noti_error_' + functionService.selectedLanguageCode,
          configKey: 'error', label: 'tai_file_that_bai'
        }"></ng-container>
      </li>
      <!-- Cấu hình hiệu ứng -->
      <li nz-submenu nzTitle="{{'hieu_ung' | translate}}" [(nzOpen)]="openMap.menu7" (nzOpenChange)="openHandler('menu7')">
        <app-choose-animations-config [type]="type" [elementChoosing]="objectChoosing" (openAnimationDetail)="openAnimationDetail($event)"
          [id_object]="objectChoosing._id" [device]="device" [class]="class" [config]="config" [staticdata]="staticdata"
          [cursorClass]="class['button']" [effect_hover]="effect_hover" [customize]="customize" type="object">
        </app-choose-animations-config>
      </li>

    </ul>
  </ng-container>
  <!-- Xem chi tiết cấu hình object -->
  <div class="view-more" *ngIf="isViewAll">
    <!-- Cấu hình chi tiết viền -->
    <div class="view_more-border" *ngIf="currentViewAll.index == 2">
      <app-borders-radius-config
                    [device]="device"
                    [class]="class"
                    [borderRadiusClass]="class['button']"
                    [id_object]="objectChoosing._id"
      >
      </app-borders-radius-config>
    </div>

    <!-- Cấu hình chi tiết hiệu ứng -->
    <div class="editor_effect-hover" *ngIf="currentViewAll.index == 3">
       <app-animations-config [type]="type" [elementChoosing]="objectChoosing" [staticdata]="staticdata" [id_object]="objectChoosing._id" [customize]="customize"
        [device]="device"></app-animations-config>
    </div>
    <!-- Cấu hình chi tiết màu gradient  -->
    <div class="container-gradient" *ngIf="currentViewAll.index == 4">
      <div class="title-head">
        <p class="text-fill">{{'phoi_mau' | translate}}</p>
        <label nz-checkbox [(ngModel)]="config['background-color'].gradient_check"
          (ngModelChange)="updateBackgroundRgb()"></label>
      </div>
      <div class="list-gradient">
        <button class="btn-gradient" *ngFor="
              let bgGradient of config['background-color']['gradient_arr'];
              let i = index
            " (click)="deleteGradient(i)" [ngStyle]="{ 'background-color': bgGradient }"
          [disabled]="!config['background-color'].gradient_check">
          <i class="delete-icon bi bi-x-circle"></i>
        </button>
      </div>
      <p class="title-head">{{ 'them_mau' | translate }}</p>
      <div class="container_add-gradient">
        <input class="input-color" [cpOKButton]="true" [(colorPicker)]="class['button']['background-color']" type="button"
          [disabled]="!config['background-color'].gradient_check"
          [style.background]="class['button']['background-color']" (colorPickerClose)="addGradient($event)" />
      </div>
      <p class="title-head">{{ 'huong_phoi_mau' | translate }}</p>
      <button class="gradient-direction" *ngFor="let type of functionService.gradientDirectionList" nz-tooltip [nzTooltipTitle]="type.name"
        (click)="chooseOption(type, $event)" [disabled]="!config['background-color'].gradient_check"
        [style.background]="'linear-gradient(' + type.deg + ', #2764EB, #EFE810)'"
        [class.active]="config['background-color'].gradient_direction === type.direction"></button>
    </div>
  </div>
</div>